module.exports = {"attributes":{"width":"18","height":"18","xmlns":"http://www.w3.org/2000/svg"},"content":"<path d=\"M9 15.92L3.44 18l.16-6.2L0 6.88l5.66-1.76L9 0l3.34 5.12L18 6.88l-3.6 4.92.16 6.2z\" />"}


//////////////////
// WEBPACK FOOTER
// ./client/components/Icon/images/star.svg
// module id = 1449
// module chunks = 0